import * as React from "react";
import { Field, ProgressBar } from "@fluentui/react-components";

const intervalDelay = 100;
const intervalIncrement = 1;

export const ProgressBarProvider = () => {
    const [value, setValue] = React.useState(0);

    React.useEffect(() => {
        const id = setInterval(() => {
            setValue(value < 100 ? intervalIncrement + value : 0);
        }, intervalDelay);
        return () => {
            clearInterval(id);
        };
    });
    return (
        <Field
            validationState="none"
        >
            <ProgressBar max={100} value={value} />
        </Field>
    );
};